 import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css'; 
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail'; 
import { toast } from 'react-toastify';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/items.jpg';     
const AddItemStaging = ({ show, onClose, itemSno, onSuccess }) => {
  const [itemDetails, setItemDetails] = useState(null);
  const baseURL = process.env.REACT_APP_API_BASE_URL;
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
  const [options, setOptions] = useState([]);
  const [rawMaterial, setRawMaterial] = useState([{ id: Date.now(), selectedOption: null, description: '', showSchedule: false,
    scheduleOption: null,}]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [savedStagging, setSavedStagging] = useState([]); // To hold item_stagging from API
  const [fieldErrors, setFieldErrors] = useState({}); // Track validation errors per row

  useEffect(() => {
    // Fetch options for staging select
    const fetchStagingOptions = async () => {
      try {
        const res = await axios.get(`${baseURL}/itemstagging/list/active`);
        const opts = res.data.data.map(item => ({
          value: item.sno.toString(),
          label: item.itemstagging_name,
        }));
        setOptions(opts);
      } catch (e) {
        console.error('Error fetching staging options', e);
      }
    };
    fetchStagingOptions();
  }, [baseURL]);

   
const fetchData = async () => {
  try {
    const [stagingRes, itemRes] = await Promise.all([
      axios.get(`${baseURL}/manage-items/stagging/${itemSno}`),
      axios.get(`${baseURL}/manage-items/${itemSno}`)
    ]);

    const item = itemRes.data?.data || {};

    // ✅ SET SCHEDULE TABS HERE
    const schedules = stagingRes.data?.data?.schedules_with_stagging || [];
    setSchedulesWithStagging(schedules);
    setActiveTab(schedules[0]?.schedule?.sno || null); // set first tab active

    // ✅ NEW: Use "item_staggings" instead of "item_stagging"
    const itemWithStagging = stagingRes.data?.data || {};
    const itemStaggings = itemWithStagging.item_staggings || [];

    // Map itemStaggings to your desired format
    const initialRawMaterial = itemStaggings.map(s => ({
      id: Date.now() + Math.random(),
      selectedOption: options.find(o => o.value === s.item_stagging_id.toString()) || null,
      description: s.description || '',
      // optionally you can also keep schedules here if needed
      schedules: s.schedules || []
    }));

    setRawMaterial(
      initialRawMaterial.length > 0
        ? initialRawMaterial
        : [{ id: Date.now(), selectedOption: null, description: '' }]
    );

    setSavedStagging(itemStaggings);
 
    setItemDetails({
  name: item.item_name || '-' + (item.item_name_ta ? ` ${item.item_name_ta}` : ''),
  quantity: (item.catering_corp_quantity ? item.catering_corp_quantity : '-') + ' ' + (item.catering_corp_unit_slug_name || '-'),
  weight: (item.item_weight ? item.item_weight : '-') + ' ' + (item.item_unit_slug_name || '-'),
  size: (item.item_size ? item.item_size : '-') + ' ' + (item.slug_name || '-'),
  category: item.itemcategory_name || '-',
  subcategory: item.itemsubcategory_name || '-',
  image: item.item_image || '-',
});


  } catch (error) {
    console.error("Error fetching data:", error);
    setSchedulesWithStagging([]);
  }
};

useEffect(() => {
  if (!itemSno || options.length === 0) return;
  fetchData();
}, [itemSno, options]);


  const handleAddConfig = () => {
    setRawMaterial([...rawMaterial, { id: Date.now(), selectedOption: null, description: '' }]);
  };

 
const handleDeleteConfig = (id) => {
  const updatedRawMaterial = rawMaterial.filter(rm => rm.id !== id);
  setRawMaterial(updatedRawMaterial);

  // Re-validate duplicates after deletion
  const seen = new Set();
  const newFieldErrors = {};

  updatedRawMaterial.forEach(rm => {
    if (!rm.selectedOption) {
      if (!newFieldErrors[rm.id]) newFieldErrors[rm.id] = {};
      newFieldErrors[rm.id].select = 'This field is required';
    } else {
      const value = rm.selectedOption.value;
      if (seen.has(value)) {
        if (!newFieldErrors[rm.id]) newFieldErrors[rm.id] = {};
        newFieldErrors[rm.id].select = 'Duplicate staging not allowed';
      }
      seen.add(value);
    }
  });

  setFieldErrors(newFieldErrors);
};


  const handleSelectChange = (id, option) => {
    setRawMaterial(rawMaterial.map(rm => (rm.id === id ? { ...rm, selectedOption: option } : rm)));

    // Clear select error if any
    if (fieldErrors[id]?.select) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        if (newErrors[id]) {
          delete newErrors[id].select;
          if (Object.keys(newErrors[id]).length === 0) delete newErrors[id];
        }
        return newErrors;
      });
    }
  };

  const handleDescriptionChange = (id, value) => {
    setRawMaterial(rawMaterial.map(rm => (rm.id === id ? { ...rm, description: value } : rm)));

    // Clear description error if any
    if (fieldErrors[id]?.description) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        if (newErrors[id]) {
          delete newErrors[id].description;
          if (Object.keys(newErrors[id]).length === 0) delete newErrors[id];
        }
        return newErrors;
      });
    }
  };

 

 
const [scheduleOptions, setScheduleOptions] = useState([]); // For schedule dropdown

 

const handleSubmit = async () => { 

    const payload = {
    item_stagging: rawMaterial.map(rm => ({
      item_stagging_id: parseInt(rm.selectedOption.value, 10),
      description: rm.description || '',
    })),
  };

  try {
    setLoading(true);
    const response = await axios.post(`${baseURL}/manage-items/stagging/${itemSno}`, payload);

    // Use response.data.data to update saved stagging and rawMaterial
    const updatedData = response.data.data || [];

    // Map it into your rawMaterial state shape
    const updatedRawMaterial = updatedData.map(item => ({
      id: Date.now() + Math.random(),
      selectedOption: options.find(o => o.value === item.item_stagging_id.toString()) || null,
      description: item.description || '',
    }));

    setRawMaterial(updatedRawMaterial);
    setSavedStagging(updatedData);
    setLoading(false);
    setIsVisible(false); 
    toast.success("Item Stagging Successfully!");
    if (onSuccess) onSuccess();
    onClose();
    // onClose();
  } catch (e) {
    setLoading(false);
    setError(e.response?.data?.message || 'Failed to save item staging');
  }
};

  const [isVisible, setIsVisible] = React.useState(true);
  const [schedulesWithStagging, setSchedulesWithStagging] = useState([]);
  const [activeTab, setActiveTab] = useState(null);

    const getTimingLabel = (timing) => {
    switch (timing) {
        case 0:
        return "Before Production";
        case 1:
        return "During Production";
        case 2:
        return "After Production";
        default:
        return "Unknown";
    }
    };


     return (
        <Modal show={show} size="xl">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Item Staging</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
              
                    <div className="row mb-3">
                        <div className="col-lg-12">
                            <div className="d-flex align-items-center justify-content-start gap-2">
                            <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                <div data-src={itemDetails?.image || idly} className="border rounded px-1 py-0">
                                <img
                                    src={itemDetails?.image || idly}
                                    alt={itemDetails?.name || 'Item'}
                                    className="cursor-pointer w-60px h-60px"
                                    onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = idly;
                                    }}
                                />
                                </div>
                            </LightGallery>

                            <div className="d-flex justify-content-between align-items-center w-100">
                                <div>
                                <label className="text-black font-w400 fs-5">{itemDetails?.name || 'Item Name'}</label>
                                <label className="text-black me-2 ms-2">|</label>
                                <label className="text-black font-w400 fs-5">{itemDetails?.category || 'Category'}</label>
                                <label className="text-black me-2 ms-2">|</label>
                                <label className="text-black font-w400 fs-5">{itemDetails?.subcategory || 'Subcategory'}</label>

                                <div className="d-block mt-1">
                                    <label className="text-black font-w400 fs-7">Quantity</label>
                                    <Badge bg="warning" className="text-white fs-7 py-0 px-1 ms-2 rounded-pill">
                                    {itemDetails?.quantity || '0'}
                                    </Badge>

                                    <label className="text-black me-2 ms-2">|</label>

                                    <label className="text-black font-w400 fs-7">Weight</label>
                                    <Badge bg="success" className="text-white fs-7 py-0 px-1 ms-2 rounded-pill">
                                    {itemDetails?.weight || '0'}
                                    </Badge>

                                    <label className="text-black me-2 ms-2">|</label>

                                    <label className="text-black font-w400 fs-7">Size</label>
                                    <Badge bg="info" className="text-white fs-7 py-0 px-1 ms-2 rounded-pill">
                                    {itemDetails?.size || '0'}
                                    </Badge>
                                </div>
                                </div> 


                            </div>
                            </div>
                        </div>
                        </div>
 

                    {isVisible ? ( 
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="mb-0">
                                    {rawMaterial.map(({ id, selectedOption, description }) => (
                                        <div key={id} >
                                            <div className="row mb-2">
                                                <div className="col-lg-4">
                                                    <label className="text-black font-w500 fs-7">
                                                        Staging Name <span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        placeholder="Select Name"
                                                        value={selectedOption}
                                                        onChange={(option) => handleSelectChange(id, option)}
                                                        options={options}
                                                    />
                                                    {fieldErrors[id]?.select && (
                                                        <span style={{ color: 'red', fontSize: '0.8rem' }}>
                                                            {fieldErrors[id].select}
                                                        </span>
                                                    )}
                                                </div>
 

                                                <div className="col-lg-7">
                                                    <label className="text-black font-w500 fs-7">Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Enter Description"
                                                        value={description}
                                                        onChange={(e) => handleDescriptionChange(id, e.target.value)}
                                                    />
                                                    {fieldErrors[id]?.description && (
                                                        <span style={{ color: 'red', fontSize: '0.8rem' }}>
                                                            {fieldErrors[id].description}
                                                        </span>
                                                    )}
                                                </div>

                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {rawMaterial.length > 1 && (
                                                        <button
                                                            className="btn btn-danger px-2 py-2"
                                                            onClick={() => handleDeleteConfig(id)}
                                                            title="Delete"
                                                            type="button"
                                                        >
                                                            <i className="fa-solid fa-trash-can fs-6 text-white"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mb-1 mt-3">
                                    <button className="btn btn-sm btn-primary py-0 px-2" onClick={handleAddConfig}>
                                        <span>
                                            <i className="fa-solid fa-plus fs-6"></i>
                                        </span>
                                        <span className="ms-2 fs-7">Add More</span>
                                    </button>
                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                                    {loading ? 'Saving...' : 'Create'}
                                    <i className="fas fa-angle-double-right ms-2"></i>
                                </Button>
                            </div>
                        </div> 

                    ) : (
                        
                        <div className="row">
                        <div className="col-lg-12">
                        {schedulesWithStagging.length === 0 ? (
                            <div className="alert alert-warning text-center">
                            No staging schedules available.
                            </div>
                        ) : (
                    <>
                    <ul className="nav nav-tabs">
                        {schedulesWithStagging.map(({ schedule }) => (
                        <li className="nav-item" key={schedule.sno}>
                            <button
                            className={`nav-link ${activeTab === schedule.sno ? "active" : ""}`}
                            onClick={() => setActiveTab(schedule.sno)}
                            >
                            {schedule.itemschedule_name}
                            </button>
                        </li>
                        ))}
                    </ul>

                    <div className="tab-content mt-3">
                        {schedulesWithStagging.map(({ schedule, stagging }) => (
                        <div
                            key={schedule.sno}
                            className={`tab-pane fade ${activeTab === schedule.sno ? "show active" : ""}`}
                        >
                            <h5 className="mb-3"> 
                            </h5>
                            <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                <tr> 
                                    <th>Staging Name</th>
                                    <th>Production ST/ET</th>
                                    <th>Timing/Work Hours</th>  
                                    <th>Work ST/ET</th>
                                    <th>Total Duration</th> 
                                    <th>Description</th>
                                </tr>
                                </thead>
                                <tbody>
                                {stagging.map((s, idx) => (
                                    <tr key={s.id}> 
                                    <td>{s.item_stagging_name}</td>
                                    <td>{schedule.production_start_time}/{schedule.production_end_time}</td> 
                                    <td>{getTimingLabel(s.timing)} / {s.working_hours} Hours</td>
                                    <td>{s.start_time}/{s.end_time}</td> 
                                    <td>{s.work_duration}</td>
                                    <td>{s.description}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            </div>
                        </div>
                        ))}
                    </div>
                    </>
                )}
                </div>
                            </div>
                        )}

                    </div>
            </div>
        </Modal >
    );
};

export default AddItemStaging;
